export enum ShirtSize {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  XLARGE = "XLARGE",
  XXLARGE = "XXLARGE",
  XXXLARGE = "XXXLARGE",
  XXXXLARGE = "XXXXLARGE",
  WOMENS_XSMALL = "WOMENS_XSMALL",
  WOMENS_SMALL = "WOMENS_SMALL",
  WOMENS_MEDIUM = "WOMENS_MEDIUM",
  WOMENS_LARGE = "WOMENS_LARGE",
  WOMENS_XLARGE = "WOMENS_XLARGE",
  WOMENS_XXLARGE = "WOMENS_XXLARGE",
  WOMENS_XXXLARGE = "WOMENS_XXXLARGE",
}

export const shirtSizeDisplayMap: Record<ShirtSize, string> = {
  [ShirtSize.SMALL]: "S",
  [ShirtSize.MEDIUM]: "M",
  [ShirtSize.LARGE]: "L",
  [ShirtSize.XLARGE]: "XL",
  [ShirtSize.XXLARGE]: "2XL",
  [ShirtSize.XXXLARGE]: "3XL",
  [ShirtSize.XXXXLARGE]: "4XL",
  [ShirtSize.WOMENS_XSMALL]: "WXS",
  [ShirtSize.WOMENS_SMALL]: "WS",
  [ShirtSize.WOMENS_MEDIUM]: "WM",
  [ShirtSize.WOMENS_LARGE]: "WL",
  [ShirtSize.WOMENS_XLARGE]: "WXL",
  [ShirtSize.WOMENS_XXLARGE]: "W2XL",
  [ShirtSize.WOMENS_XXXLARGE]: "W3XL",
};

// Helper function to get display text for a shirt size
export const getShirtSizeDisplay = (size: ShirtSize): string => {
  return shirtSizeDisplayMap[size];
};

// Helper to get all shirt sizes as array (for dropdowns)
export const getAllShirtSizes = (): ShirtSize[] => {
  return Object.values(ShirtSize);
};
